import { render } from "./editli.vue?vue&type=template&id=9f3280f6&scoped=true"
import script from "./editli.vue?vue&type=script&lang=js"
export * from "./editli.vue?vue&type=script&lang=js"

import "./editli.vue?vue&type=style&index=0&id=9f3280f6&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3280f6"]])

export default __exports__